module.exports = __webpack_public_path__ + "assets/img/icon-pet-blue.5077c3e6.png";